import { Map } from 'immutable';

import {
  SAVE_TRUSTWORTHY_BIOMETRY_REQUEST,
  SAVE_TRUSTWORTHY_BIOMETRY_FAILURE,
  SAVE_TRUSTWORTHY_BIOMETRY_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === SAVE_TRUSTWORTHY_BIOMETRY_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === SAVE_TRUSTWORTHY_BIOMETRY_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === SAVE_TRUSTWORTHY_BIOMETRY_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
